import { LoginServiceService } from '../services/login-service.service';
import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators, FormControl} from '@angular/forms';
//import {MatButtonModule} from '@angular/material/button';
import { LoginModel } from '../models/login-model';
import { Router, ActivatedRoute } from '@angular/router';
import {Globals} from '../../shared/globals';
// import { MessagingService } from '../../messaging.service';
// import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-login-app',
  templateUrl: './login-app.component.html',
  styleUrls: [ './login-app.component.scss']//'./login-app.component.css',
})

export class LoginAppComponent implements OnInit {

  loginForm : FormGroup;
  loginmodel : LoginModel = new LoginModel();
  returnUrl: string;
  errors: string[];
  disableButton: boolean;
  UserName:string='';
  Pass:string='';
  loading = false;
  isTextFieldType: boolean;
  constructor(private formBuilder : FormBuilder,private loginService : LoginServiceService,
    private router: Router,private route: ActivatedRoute) { 
    localStorage.removeItem('userconfig');
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');          
    localStorage.removeItem("username");
    this.UserName = this.route.snapshot.paramMap.get('UserName');
    this.Pass =this.route.snapshot.paramMap.get('Pass');
   
  }
  ngOnInit() {
    this.errors = [];
    this.loginForm = this.formBuilder.group(
      {
        username : [this.UserName,Validators.required],
        password : [this.Pass,Validators.required]
      }
    );
    localStorage.removeItem('userconfig');
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');          
    localStorage.removeItem("username");
    this.loginForm.controls['username'].setValue(this.UserName);
    this.loginForm.controls['password'].setValue(this.Pass);
    if(this.UserName!=undefined && this.Pass!=undefined && this.Pass!='' && this.UserName!=''){
      this.onSubmit();
    }
    // this.anglurService.success('Hi!', 'Everything is initialized!');
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  get(key:string) : string
  {
    return this.loginForm.controls[key].value;
  }

  onSubmit() : void {
    //console.log(this.loginForm.value);
    //console.log(this.get('username'));
    //console.log(this.get('password'));
    //debugger
    this.errors = [];
    this.loginmodel.Username = this.get('username');
    this.loginmodel.Password = this.get('password'); 
    this.disableButton = true;
    this.loading=true;
    setTimeout(() => { 
      this.disableButton = false;
      this.loading=false;
      this.loginService.AuthenticateUser(this.loginmodel)
      .subscribe((response) => {
          Globals.userconfig = response;
          if(response.ID>0)
          {
            //debugger
            localStorage.setItem('userconfig', JSON.stringify(response));
            localStorage.setItem('token', response.Token.toString());
            sessionStorage.setItem('token', response.Token.toString());            
            localStorage.setItem("username",this.loginmodel.Username );
            
            // if(response.AppModuleType==1)
            // {
            //   if(this.returnUrl == '/')
            //   {
            //     this.returnUrl= '/pages/trcheckin';
            //   }              
            // }
            //this.router.navigateByUrl(this.returnUrl);
            this.router.navigate(['/pages/etm-dashboard']);
          }
          else{
            this.errors.push(response.Name);
          }
      },
      (err) => { 
      this.errors.push("Có thể app Server chưa được bật.");
    })
    }, 3000);   
    

  }
  // changePasswordType(){
  //   debugger
  //     this.isTextFieldType = !this.isTextFieldType;
  //   }

}